import { useEffect, useEffectEvent, useState } from 'react';
import { matchPath, useLocation } from 'react-router';

// Performs a nested search for active route menu key
// also identifies parent keys for automatic submenu opening
let findKeys = (routesToMatch, pathname) => {
  let activeRouteKey = '';
  let activeParentKeys = [];

  routesToMatch.some((route) => {
    if (route.children) {
      let [activeSubKey, openSubKeys] = findKeys(route.children, pathname);
      activeRouteKey = activeSubKey;
      if (activeRouteKey) {
        activeParentKeys = [route.key, ...openSubKeys];
      }
      // `end: false` keeps the v5 behaviour of matching a route prefix, so a
      // menu item stays highlighted on its sub-pages.
    } else if (matchPath({ path: route.path, end: false }, pathname)) {
      activeRouteKey = route.key;
    }
    return !!activeRouteKey;
  });

  return [activeRouteKey, activeParentKeys];
};

// Keeps track of the active nav key based on the current application route
// Automatically opens parents of sub-menu items
// I'm annoyed ant design doesnt have this functionality out of the box.
const useNavigationKeyManager = (routesToMatch = []) => {
  let { pathname } = useLocation();
  let [activeRouteKey, activeParentKeys] = findKeys(routesToMatch, pathname);
  let [openKeys, setOpenKeys] = useState([]);

  let toggleOpenKey = (key) => {
    let keyIndex = openKeys.findIndex((openKey) => openKey === key);
    if (keyIndex > -1) {
      setOpenKeys([
        ...openKeys.slice(0, keyIndex),
        ...openKeys.slice(keyIndex + 1),
      ]);
    } else {
      setOpenKeys([...openKeys, key]);
    }
  };

  const updateOpenKeys = useEffectEvent(() => {
    setOpenKeys([...openKeys, ...activeParentKeys]);
  });

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    updateOpenKeys();
  }, [activeRouteKey]);

  return [activeRouteKey, openKeys, toggleOpenKey];
};

export default useNavigationKeyManager;
